import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';

export const getLanguage = () => {
  const language = (navigator.language || 'zh');
  return localStorage.getItem('lang') || language;
};

export const getLanguageData = (locale?: string) => {
  const l = locale || getLanguage();
  if (l.includes('en')) return en;
  return zhCn;
};
